// Espelha GetGroupScorePart do back (QueueScoreBuilder).
export const TME_PLANO_2_DEGRAU_MIN = 30;
export const TME_PARTICULAR_2_DEGRAU_MIN = 40;
export const TME_PLANO_3_DEGRAU_MIN = 45;
export const TME_PARTICULAR_3_DEGRAU_MIN = 60;

export function fatorPesoEscalonado(key: string, planType: string, waitMs: number): 1 | 2 | 3 {
  const waitMin = waitMs / 60000;
  if (key === 'tme15Plano' && planType !== 'PRIVATE') {
    if (waitMin > TME_PLANO_3_DEGRAU_MIN) return 3;
    if (waitMin > TME_PLANO_2_DEGRAU_MIN) return 2;
  }
  if (key === 'tme20Particular' && planType === 'PRIVATE') {
    if (waitMin > TME_PARTICULAR_3_DEGRAU_MIN) return 3;
    if (waitMin > TME_PARTICULAR_2_DEGRAU_MIN) return 2;
  }
  return 1;
}
